import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { imageDelete } from 'redux/propsSlice';
import ButtonAccept from 'utils/buttons/ButtonAccept';
import ButtonClose from 'utils/buttons/ButtonClose';
import messageHandler from 'utils/messageHandler';
import PropTypes from 'prop-types';
import { imageDeleteProject } from 'redux/projectsSlice';
import ButtonDelete from 'utils/buttons/ButtonDelete';
import ModalButtonsContainer from 'sites/common/ModalButtonsContainer';
import { getImageUrl } from '../../../../../utils/imageUrl';

const dltObj = {
  property: imageDelete,
  project: imageDeleteProject
};

const urlObj = {
  project: 'projects',
  property: 'properties'
};

const ImageDeleteModal = ({
  image,
  accessor,
  setShow,
  setData,
  data,
  setStepStatus,
  parent,
  willBePaused
}) => {
  const dispatch = useDispatch();

  const [modalWillBePaused, setModalWillBePaused] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const handleClose = () => setShow(false);

  const getPropertyImageUrl = (prop, filename, accessor) => {
    if (!prop.images || prop.images.length === 0) {
      return '/uploads/properties/no-image.jpg';
    }

    console.log(accessor);

    const image =
      accessor == 'images'
        ? prop.images.find(img => img?.filename === filename)
        : prop.houseMaps?.find(img => img?.filename === filename);

    const entityType = prop.units ? 'projects' : 'properties';
    return getImageUrl(image, entityType, prop._id);
  };

  const handleDelete = async ({ id, fileName }) => {
    try {
      if (!isLoading) {
        setIsLoading(true);
        const response = await dispatch(dltObj[parent](id, fileName, accessor));
        if (response && response?.status < 400) {
          setData(prev => ({ ...prev, [accessor]: response.data.result }));
          setStepStatus(prev => ({
            ...prev,
            [accessor]: response.data.result
          }));

          messageHandler(
            'success',
            accessor === 'images'
              ? 'Imagen borrada correctamente'
              : 'Plano borrado correctamente'
          );
          handleClose();
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <Modal
        keyboard={true}
        show={true}
        onHide={handleClose}
        backdrop="static"
        centered
      >
        <Modal.Header closeButton>
          <FontAwesomeIcon
            icon="fa-trash-can"
            title="Eliminar"
            size="1x"
            style={{ marginRight: 8, color: '#e63757' }}
          />

          <Modal.Title>
            Eliminar {accessor === 'images' ? 'imagen' : 'plano'}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="mb-4">
            <img
              src={getPropertyImageUrl(data, image, accessor)}
              className="rounded my-3"
              style={{ width: '100%' }}
            />
            <p className="mt-2">
              ¿Está seguro que quiere borrar{' '}
              {accessor === 'images'
                ? 'esta imagen? No podrá recuperarla.'
                : 'este plano? No podrá recuperarlo.'}
            </p>
          </div>

          <ModalButtonsContainer>
            <ButtonClose
              text="Cancelar"
              funcion={handleClose}
              variant="secondary"
            />
            <ButtonDelete
              text={isLoading ? 'Cargando' : 'Eliminar'}
              funcion={
                willBePaused ? () => setModalWillBePaused(true) : handleDelete
              }
              data={{ id: data._id, fileName: image }}
              disabled={isLoading}
            />
          </ModalButtonsContainer>
        </Modal.Body>
      </Modal>

      <Modal show={modalWillBePaused} centered>
        <Modal.Header closeButton>
          <Modal.Title>La publicación se pausará</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Al eliminar esta imagen, la publicación se pausará hasta que vuelva
            a tener como mínimo tres imágenes.
          </p>
          <p className="m-0">¿Está seguro que desea continuar?</p>
        </Modal.Body>

        <Modal.Footer>
          <div
            className="d-flex flex-column flex-sm-row justify-content-end button-container"
            style={{ gap: '1rem' }}
          >
            <ButtonClose
              text="Cancelar"
              funcion={() => {
                setModalWillBePaused(false);
                handleClose();
              }}
              variant="secondary"
            />

            <ButtonAccept
              text="Pausar"
              funcion={handleDelete}
              data={{ id: data._id, fileName: image }}
              disabled={isLoading}
            />
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

ImageDeleteModal.propTypes = {
  image: PropTypes.string,
  accessor: PropTypes.oneOf(['images', 'houseMaps']),
  setShow: PropTypes.func,
  setData: PropTypes.func,
  data: PropTypes.object,
  setStepStatus: PropTypes.func,
  parent: PropTypes.oneOf(['property', 'project']).isRequired,
  willBePaused: PropTypes.bool
};

export default ImageDeleteModal;
